/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_TypeInputs */

const vi_vehicle_type = /** @type {(inputs: Vehicle_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại xe`)
};

/**

* @param {Vehicle_TypeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_type = /** @type {((inputs?: Vehicle_TypeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_TypeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_type(inputs)
});